import { render } from "./Url.vue?vue&type=template&id=1534e909&scoped=true"
import script from "./Url.vue?vue&type=script&lang=js"
export * from "./Url.vue?vue&type=script&lang=js"

import "./Url.vue?vue&type=style&index=0&id=1534e909&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1534e909"]])

export default __exports__